import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { Corte } from '../../models/corte/corte';

@Injectable({
  providedIn: 'root',
})
export class CortesService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.CORTES}`;
  constructor(private http: HttpClient) {}

  getCortes(): Observable<Corte[]> {
    return this.http.get<Corte[]>(this.apiUrl);
  }
}
